import React, { useEffect, useState } from "react";
import { BrainGameApi } from "../../system/api/BrainGameApi";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { brainGame } from "../../system/types/brainGame/brainGame";
import { dispatch } from "../../App";
import { actions } from "../../redux";
import { localStorageHelper } from "../../system/helper/localStorage";
import { localStorageConfig } from "../../system/config/localStorage";
import { getRandomItemByLevel } from "../../system/helper/brainGameRandom";
import { LanguageSelect } from "./LanguageSelect";
import { GameInput } from "./GameInput";

const BrainGameBase = () => {

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');

    const [projectId, setProjectId] = useState<string>('');
    const [brainGameData, setBrainGameData] = useState<brainGame | undefined>();

    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }

        if (state.brainGame.gameData !== brainGameData) {
            setBrainGameData(state.brainGame.gameData);
        }
    });

    const initBrainGameData = async () => {

        let data = await loadBrainGameData();
        const storeage = new localStorageHelper();
        const storeKey = localStorageConfig.brainGameData + '_' + projectId;

        if (data !== null) {
            dispatch(actions.brainGame.setData(data));
            storeage.setItem(storeKey, data);
            return;
        }

        data = storeage.getItem<brainGame>(storeKey);

        if (data !== null) {
            dispatch(actions.brainGame.setData(data));
            return;
        }
    };


    const loadBrainGameData = async () => {
        const api = new BrainGameApi(sessionToken, sessionEmail);

        const data = await api.initBrainGameData(projectId);

        if (data.code >= 400) {
            return null;
        }

        return data.data;
    }

    useEffect(() => {

        if (sessionToken === '') {
            return;
        }

        if (sessionEmail === '') {
            return;
        }

        if (projectId === '') {
            return;
        }

        initBrainGameData();
    }, [sessionToken, sessionEmail, projectId]);

    return (
        <div className="brainGame">
            {typeof brainGameData === 'undefined' ? null :
            <>
                <LanguageSelect></LanguageSelect>
                <GameInput></GameInput>
            </>
            }
        </div>
    );
}

export { BrainGameBase };
